import { i18nLanguages } from '@readme/iso';

const I18N_LANG_SUFFIX_PATTERN = new RegExp(`-(${i18nLanguages.join('|')})(?=\\b|_)`);

/**
 * Removes the language suffix from a version or branch name.
 *
 * @param   {string} versionName the version or branch name to clean up
 * @returns {string}             a clean version or branch name without the lang suffix
 *
 * @example cleanLangVersionName("1.0-fr")            →  "1.0"
 * @example cleanLangVersionName("2.0-ja_my_branch")  →  "2.0_my_branch"
 */
export default function cleanBranchName(versionName: string) {
  return versionName.replace(I18N_LANG_SUFFIX_PATTERN, '');
}
